import { GroupEntity } from '@backstage/catalog-model';
import { Progress } from '@backstage/core-components';
import { ScoreBoard } from './ScoreBoard';
import { ScoreBoardType } from './ScoreBoardType';
import { useEntity } from '@backstage/plugin-catalog-react';
import { useGetSecretScores } from './hooks/useGetSecretScores';

import { SimpleScore, useTeamList } from '@internal/ui-common';

export const SecretScoreBoard = () => {
  const { entity: departmentGroup } = useEntity<GroupEntity>();
  const { teams, isLoading } = useTeamList(departmentGroup);

  const { scores } = useGetSecretScores({ teams: isLoading ? [] : teams });

  if (isLoading || scores === undefined) {
    return <Progress />;
  }
  return (
    <ScoreBoard<SimpleScore> scores={scores} type={ScoreBoardType.SECRETS} />
  );
};
